import { useMutation } from "@tanstack/react-query";
import { validateUploadRetailLocationsFile } from "../services/RetailLocationService";

export function useRetailLocationValidateImport() {
    return useMutation({
        mutationFn: validateUploadRetailLocationsFile,
    });
}
